export const en_US: Record<string, any> = {
  pluginName: 'Components',
};
